var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "256 91 623 657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M603 107s43 7 48 39c0 0-1 19-6 28-2 4-4 11-7 12 0 0-7 5-7 12 0 0 1 9 4 12 0 0 3 4-2 6s-8 1-8 1l-1 1-1 8v3l-3 2-6-2s-1 1 4 3c3 1 1 4 0 5l-4 3-7 11c-4 10-21 6-30-1 0 0-65-23-60-71s18-52 41-69c15-12 28-8 34-8 4 0 10 5 11 5Zm38 22-7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m641 129-3 2 2-1 1-1Zm-3 2-4 3 2-1 2-2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 168c-3 4-1 12-1 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 168Zm-1 4Zm0 0Zm0 3v11-11Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 169c1-5 3 2 3 3 1 5 0 10-1 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M645 168v1-1Zm0 1 1 4v-1l-1-3Zm1 4 1 1v-1h-1Zm1 1Zm-1 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 165v-2l3 4 3 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M643 163Zm0 0Zm0 0h-1 1Zm-1 0 1 2-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 164c1-1 0-3 2-4l2 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M647 161h-1 1Zm0 0h1-1Zm1 0v1-1Zm0 1v1-1Zm0 1 1 1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648 157 6 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648 157 6 20-6-20Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 156c6 5 7 11 10 17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m646 156 4 4c3 4 4 9 6 13-2-4-3-9-6-13l-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 145c5 8 8 18 10 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 145Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 128c3 0 6 2 9 4 8 5 13 18 14 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 128Zm3 1Zm1 0 4 2-4-2Zm4 2a27 27 0 0 1 1 1l-1-1Zm4 4h1-1Zm1 0Zm4 5Zm2 5Zm2 5 1 2-1-2Zm1 2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 138c7 6 15 18 15 28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 138Zm5 6h1-1Zm1 0 2 3-2-3Zm2 3 3 6v-1l-3-5Zm3 6 1 3-1-3Zm1 3 2 3-2-3Zm2 3v1-1Zm0 1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 120c9 1 22 9 28 16 2 2 2 6 3 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632 121 2 1-2-1Zm2 1 4 1-4-1Zm5 2Zm4 2 2 1-2-1Zm2 1 3 2h-1l-2-2Zm3 2 3 2-3-2Zm4 3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 108c-1-4 3-5 7-6 7 0 25 0 31 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 102 6 1-6-1Zm6 1h4-4Zm4 0 3 1-2-1h-1Zm3 1h2-2Zm2 0Zm-24-2h-2 2Zm-2 0-1 1h-2l3-1Zm-3 1h-1 1Zm-1 0Zm-2 1v1-1Zm0 1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 111h23l19 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M608 110h-5l6 1-1-1Zm1 1h7-7Zm-6-1-3 1 3-1Zm-3 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 114c15-7 31-6 47-1 4 1 7 1 8 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M643 113Zm1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 120c14-3 25 2 37 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m614 120 12-1-12 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 120c10 0 20 2 29 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624 120 29 4-29-4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 119c9-1 23 0 31 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M637 119h4-4Zm4 0h4-4Zm4 0h2-2Zm2 0Zm7 2Zm3 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 118c11 1 23 1 32 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M625 118c9 1 19 1 27 5l5 2-5-2c-8-4-18-4-27-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623 121 30 7c4 1 8 2 10 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m637 124 13 3-7-2-6-1Zm13 3 3 1-2-1h-1Zm5 2Zm2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 128c8 1 21 5 26 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M635 128Zm8 2 4 1-4-1Zm4 1 4 2-1-1-3-1Zm4 2 3 1-3-1Zm3 1 2 2-2-2Zm2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604 111 2-3c8-3 25 0 34 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M615 107Zm-6 0h-1l-3 1 3-1h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 107c11-3 33-7 45-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 107c9-3 20-4 30-5l15 3-15-3c-10 1-21 2-30 5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 106c12-7 28-5 41-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 106c12-7 28-5 41-2-13-3-29-5-41 2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 107c10-10 26-9 39-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M597 98a71 71 0 0 0 1 0h-1Zm-9 1h-2 2Zm-2 0h-1l-1 1 2-1Zm-2 1Zm-7 2-2 1 2-1Zm-2 1-1 1 1-1Zm-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 109c7-6 17-5 26-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m592 109 5-3c7-2 14-2 21-2-7 0-14 0-21 2l-5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m596 110 24-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m620 109-24 1 24-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 110c8-2 22-7 30-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M615 106h-1 4-3Zm3 0h2-2Zm2 0Zm2 1h1-1Zm1 0Zm-9-1h-2 2Zm-2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597 109 27-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m597 109 27-1-27 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 104 12-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588 97-12 7 12-7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 106 3-15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m576 106 3-15-3 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 106c-4-5 1-10 4-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 106-1-2c-1-5 3-9 5-12-2 3-6 7-5 12l1 2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 105c3-6 8-10 14-14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M576 105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579 102 13-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579 102 13-9-13 9Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 100c5-3 10-6 16-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m583 100 9-5 7-1a38 38 0 0 0-16 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 103c5-2 12-6 18-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M578 103c6-3 11-6 18-6-7 0-12 3-18 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 106c7-2 14-5 22-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 106c7-2 14-5 22-5-8 0-15 3-22 5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 104c2-5 14-4 18-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 100h-1 1Zm0 0Zm-1 0h-5 5Zm-5 0-2 1 2-1Zm-2 1-1 1 1-1Zm-1 1h-1 1Zm-1 0-1 1 1-1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599 108 19-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 106Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601 108c1 0 13-1 12 1l-14-1 5 1h8c1-3-8-3-9-3h-3c2 3 11 3 13 3h-2l-2-1h-9l3 1h5-7l-4 1c-1-1 2-1 3-2h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 106Zm4 0 2 1-2-1Zm2 1h1-1Zm1 0h1-1Zm1 0v2-2Zm-12-1 1 1-1-1Zm1 1 1 1h8a38 38 0 0 0-8 0l-1-1Zm1 1Zm0 0h-3 1l-2 1h1l1-1h1-1 2Zm0 0h1-1Zm1 0Zm-1 0Zm0 0h3-3Zm3 0h-3 3Zm0 1h1-1Zm-3 0h6l2 1-8-1Zm5 0h1-1Zm-9 0h-1 1Zm-1 0v1-1Zm0 1h2-2Zm16-1h-1 1Zm-1 0Zm-2 0h2-2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601 106c2 5 12 4 17 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M601 106Zm2 3h2-2Zm2 0 1 1-1-1Zm1 1h2-2Zm2 0Zm6 0a62 62 0 0 1 1 0h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 119c9 2 18 5 24 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M623 119Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 118c10 1 18 3 23 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 118c6 1 13 2 18 6l5 6-5-6c-5-4-12-5-18-6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 116c10 2 19 5 26 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 116c7 1 14 3 20 7l6 5-6-5c-6-4-13-6-20-7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 115c8 1 22 7 20 17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m626 115 4 1c8 2 17 7 16 16 1-9-8-14-16-16l-4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 115c10 4 20 6 24 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 115c7 3 17 5 21 12l3 5-3-5c-4-7-14-9-21-12Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 106c-4-5-12-8-18-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M568 106Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 107c-1-4-8-6-12-7h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554 100 2 1h-1l-1-1Zm2 1 4 1h-1l-3-1Zm4 1 2 1-2-1Zm2 1 1 1-1-1Zm1 1v1-1Zm0 1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 113c9-2 20-4 29-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M533 113c10-2 19-4 29-2-10-2-19 0-29 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 117c8-1 16-4 24-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M536 117c8-1 16-4 24-3-8-1-16 2-24 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 117c-7 0-15 4-21 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 117c-8 1-14 4-21 7 7-3 13-6 21-7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 121c-6-3-19 4-22 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543 120-2 1 2-1Zm0 0Zm-2 1h-2 2Zm-2 0h-1l-2 1 3-1Zm-3 1-1 1 1-1Zm-1 1-2 1 2-1Zm-2 1-2 1 2-1Zm12-4Zm-16 6-2 2 2-2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 126c-8-2-16 5-20 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 126c-8-2-16 5-20 11 4-6 12-13 20-11Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 126c-7 0-14 8-19 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 126Zm-4 1h-1 1Zm-1 0-1 1 1-1Zm-1 1-3 1v1l3-2Zm-3 2h-1l-1 1 2-1Zm-2 1-8 8 8-8Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 117c-7 0-15 4-21 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 117c-8 0-15 4-21 7 6-3 13-7 21-7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 117c-1-1-2-3-4-3l-8 2-7 3 3 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M550 114h2-2Zm0 0h-1 1Zm-1 0h-1 1Zm-1 0-1 1 1-1Zm-1 1h-1l-5 1 6-1Zm-7 2-2 1h-1l3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556 115-1-3c-2-1-17 3-18 5-1 1 1 2 2 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M554 112h-1 1Zm0 0h2-2Zm-1 0h-3 3Zm-3 0Zm-5 2-3 1 3-1Zm-3 1h-2l-1 1 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558 113-4-2h-15v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 110h6-6Zm0 0Zm7 0 2 1-1-1h-1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 113c-5-3-19-6-23-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M543 109v1l2-1h-2Zm2 0 2 1-2-1Zm2 1h1-1Zm1 0h3-3Zm3 0Zm-8 0h-3 3Zm-3 0h-1 1Zm-1 0-1 1 1-1Zm-1 1Zm17 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 112c-6-4-11-5-18-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556 112-4-3-14-1 14 1 4 3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 113c-4-6-10-8-17-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m558 113-4-5-13-4 13 4 4 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 129c-8 3-17 8-23 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 129Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 135c-9 3-19 11-22 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 135Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 142c-9 3-13 12-18 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 142c-9 3-13 12-18 19 5-7 9-16 18-19Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532 139-2-2c-3 1-14 17-14 19l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530 137-1 1 1-1Zm-1 1-1 1 1-1Zm-1 1-2 1v1l2-2Zm-4 5-1 1-3 4 4-5Zm-4 5-2 3-1 1 3-4Zm-3 4v1-1Zm0 1-1 2 1-2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 131c-9 5-19 19-16 30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M533 131Zm-5 4Zm-3 3-2 1 2-1Zm-2 1Zm-2 3Zm-1 3-1 1v1l1-2Zm-1 2v1l-2 3 2-4Zm-2 4v3-3Zm0 3v2-2Zm0 2-1 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 146c-7 3-18 20-19 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 146Zm-3 1Zm-1 1Zm-1 1-2 3 2-3Zm-2 3-1 1 1-1Zm-1 1-1 1-1 2 2-3Zm-2 3-2 3 2-3Zm-2 3-1 2 1-2Zm-1 2-2 2-1 2 3-4Zm-3 5Zm-1 2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 149c-8 4-14 21-17 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 149Zm-3 3Zm-1 1-2 3 2-3Zm-2 3-2 2v1l2-3Zm-2 3-1 1-2 5 3-6Zm-3 6-2 4 2-4Zm-2 4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 158c-6 7-9 15-8 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M524 158Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 158c-4 6-4 13-7 20l-5 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 158c-3 5-4 12-6 18l-5 10-1 5 1-5 5-10c2-6 3-13 6-18Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 162c-6 8-7 17-8 27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m520 162-3 6c-3 7-4 14-5 21 1-7 2-14 5-21l3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 163c-8 5-6 22-3 30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M513 181v5-5Zm0 5v1-1Zm0 1 1 1a66 66 0 0 0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 172c-4 9-2 18 0 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m517 172-2 8 2-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 176c-3 7-2 13-1 22v8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 198v7-7Zm0 8Zm0 0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521 177a248 248 0 0 0 0 28v3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521 203v4-4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 179c-2 2-4 3-4 5-2 5 1 13 1 19v3c1 2 0 5 1 4l1-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M516 183Zm-1 2v2-2Zm0 2Zm0 0v1l1 4-1-5Zm1 5v2-2Zm1 8v3-3Zm2 7a6 6 0 0 1 0 1v-1Zm-1 2v1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 175c-4 7 1 21 3 29l2 8 1 3c2-3 0-7-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M516 178v1-1Zm0 1v1-1Zm0 1v3-3Zm0 3v3-3Zm0 3v1l1 6-1-7Zm1 7 1 3-1-3Zm6 16 1 2-1-2Zm1 2v2-2Zm0 2v1-1Zm0 1-1 1v-1h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 192c-1 9 2 13 5 21l4 7-1-3-2-6v-4l7 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525 207 1 1-1-1Zm1 1 1 2-1-2Zm1 2 1 2v-1l-1-1Zm1 2 1 5-1-5Zm1 5Zm-3-3 2 4v1l-2-5Zm3 6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 185c0-8-4 5-4 6v13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515 188-1 6v1l1-7Zm-1 7Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 171c-5 7-7 13-9 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M520 171a55 55 0 0 0-9 22l3-12 6-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 168c-6 4-8 12-11 19l-1 3c1 1 2-2 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 168Zm-3 3-1 1 1-1Zm-1 1-1 2 1-2Zm-1 2-2 4 2-4Zm-2 4-2 4v1l2-5Zm-2 5-2 4 2-4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521 163c-8 4-10 13-12 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M521 163c-8 4-10 13-12 21 2-8 4-17 12-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519 164 1-3-3-1-4 7-2 7-2 7h4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M518 160Zm0 0h1-1Zm1 0h1-1Zm-1 0h-1 1Zm-1 0Zm0 1Zm3-1v1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523 156-3-1c-5 2-13 13-12 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 155h-1l-1 1 2-1Zm-2 1-2 2h-1l3-2Zm-3 2v1l-1 1 1-2Zm-1 2-2 3 2-3Zm-2 3-1 2 1-2Zm-1 2-1 2h-1l2-2Zm-2 2v2-2Zm0 2-1 1 1-1Zm-1 1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 150c-6 2-10 7-13 12 0 1-2 3-1 4l2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 150c-5 2-8 5-11 10l-1 1-1 2-1 2v1l2-1-2 1v-1l1-2 1-2 1-1c3-5 6-8 11-10Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 141c-6-2-9 5-12 9l-3 4-2 3c2 1 3-1 5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 141Zm0 0Zm-2 0-1 1 1-1Zm-1 1-2 1 2-1Zm-2 1-1 1 1-1Zm-1 1-1 2 1-2Zm-2 3-1 1-1 2 1-1 1-2Zm-4 6-1 2-2 2 2-2 1-2Zm-3 4Zm0 0Zm0 0h1-1Zm2 0Zm0 0h-1 1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 135c-7-4-13 5-16 10-2 2-5 4-4 6l3 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 135h-2c-5-2-9 3-12 7l-1 2-2 2-3 3v3h3-3v-3l3-3 2-2 1-2c3-4 7-9 12-7h2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 129c-7-4-14 2-20 6-1 1-2 1-2 3l3 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M537 128h-1 1Zm0 0 4 1-3-1h-1Zm-1 0Zm-3 0Zm-1 1Zm-2 1h-2 2Zm-2 0-2 2 2-2Zm-2 2-2 1 2-1Zm-5 3-1 1 1-1Zm-1 1Zm-1 1Zm0 0v1-1Zm0 1h1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 123c-8-3-15 4-20 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544 123-4-1c-7 0-12 6-16 11 4-5 9-11 16-11l4 1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551 120c-8-2-17 3-23 8-1 1-2 1-2 3l3 1 4-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M547 120h-1a17 17 0 0 1 1 0Zm-1 0h-1 1Zm-1 0-3 1 3-1Zm-3 1h-2 2Zm-2 0-3 1 3-1Zm-3 1-2 1 2-1Zm-2 1-2 2 2-2Zm-2 2-5 3 5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 118c-1-1-6-5-8-5h-10c-1 1-3 1-3 3l4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 113h-2 2Zm-3 0h-1 1Zm-1 0h-1 1Zm8 0 3 2-1-1-2-1Zm3 2 5 3-4-3h-1Zm-13-1h-2 2Zm-3 1v1-1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562 114-1-5v-8l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m562 104-1 5 1 2v-7Zm0 5v5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562 113-1-3c0-2 5-18 4-8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M565 99Zm0 0Zm0 0Zm0 0v1-1Zm0 1v2-2Zm-2 3v1l-1 2 1-3Zm-1 3v2h-1l1-2Zm-1 2v3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 114c0-3 8-21 6-12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m560 114 1-4a72 72 0 0 1 4-9c0-1 1-3 1-1a6 6 0 0 1 0 1v1-2c0-2-1 0-1 1a34 34 0 0 0-1 2l-3 7-1 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 110c0-4 12-25 6-11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M571 95Zm0 0c1 0 1 0 0 0 0 0 1 0 0 0Zm0 0v1-1Zm-2 3v1l-2 3 2-4Zm-2 4-1 3-1 1 2-4Zm-2 4-1 4 1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 109c3-5 7-9 11-12l4-3v4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M587 94Zm0 0h-1 1Zm-1 0-1 1 1-1Zm-1 1-2 2 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 105c2-4 9-14 12-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M588 96Zm0 0Zm0 0h-1 1Zm-1 0-2 1 2-1Zm3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 107c3-5 6-6 12-9l4-2c1-1 4-3 4-1l-4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m570 107 4-5 9-5 4-2 2-1 1 1-2 2-2 1 2-1 2-2-1-1-2 1-4 2-9 5-4 5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 110c3-6 8-13 15-14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M560 110c3-6 8-13 15-14-7 1-12 8-15 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567 112 1-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567 112 1-12-1 12Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 110c-1-5-1-10 3-13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M569 110c-1-5-1-10 3-13-4 3-4 8-3 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 119c-4-5-11-8-15-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M546 119c-3-4-9-8-14-4l-1 2 1-2c5-4 11 0 14 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 116c-8-1-15 2-20 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 116c-8-1-14 2-20 6 6-4 12-7 20-6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538 122c-8 0-13 2-18 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538 122-7 1 7-1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538 124c-8-1-17 6-23 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M538 124c-9-1-17 6-23 11 6-5 14-12 23-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 131c-8 2-13 7-18 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530 131-5 2 5-2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 136c-6 1-10 7-13 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 136c-6 1-10 7-13 12 3-5 7-11 13-12Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 192h1m37 26s5 10-6 14c0 0 17 28 55 25l4-7 1-6c0-6-6 1-6 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 234s-36 4-48 28c0 0-10 12-8 28 0 0-2 31 6 42s-8 38 1 45c0 0-8 26-3 32 0 0-15 8-13 26 2 12-25 27-12 63 5 16 10 18 55 59 0 0 9 23 22 30 0 0-10 31 1 35l-3 13s38-2 53 5c0 0 3-6 5-16 0 0 14 0 14-22-1-10 4-15 2-28-3-18-10-43-9-57 0 0 2-16 6-22 0 0 4 2 6-2 1-3 19-54 11-99-8-44 10-70-21-129 0 0-21-17-29-17-8 1-31-20-31-20s-3-4-21-5c-7-1-20-3-31 3 0 0-11 11 0 11 0 0-4 16 9 16m52 374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 621s-7 19-2 42c0 0 7 22 5 31 0 0-6 23-4 27 0 0-1 4 15 3 0 0 33 8 45 5 0 0 13-3 7-12l-2-3s-10-13-21-16l2-8s-1-7-5-1c0 0 6-49 6-63 0 0-12-13-23-11-11 1-23 6-23 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 698s-8-4-6 1 5 6 5 6m-28 43h1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M516 742a7 7 0 0 0 8 12 42 42 0 0 1-2-4l-1-2-2-2-2-3-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 710s16 2 8 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M587 703a7 7 0 1 0-1 14h7c2 1 2 5 2 7v1c2-2 4-4 5-8l-2-6-2-4-1-1-1-1-7-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619 355 41 2m-57 0 51-3s-2-16 5-13c0 0 1-5 5-6 5 0 1-3 6-4 3-1 7-1 11 1 0 0 12-8 17 5 0 0 2-3 6 3 0 0 8 7 4 15 0 0-2 6-6 8 0 0 11-2 6 5 0 0-18 7-18 3 0 0-15 4-23 8 0 0-59 17-62 16m50-10h1m0-2s4 42 9 50c0 0 27-6 31-9 0 0-7-19-5-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 398s8 0 11 3c0 0 12-11 14-15l-8-11s7-16 12-16c0 0 22 5 23 11 0 0 2 4 0 9-1 3 6-2 6-2s3-7-2-12c-5-4-26-15-36-16l-5-1-48 27-1 10m14-43v-1m-3-2v-1m-16 19-6-10s-2-1 6-8c7-7 13-4 13-4l6 7c1 1-5 21-5 21m0 70s-3 2 0 3c0 0 29-8 32-10 0 0 2-1-1-2l-31 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 435s3 8-3 17l-36 63-10 16-32 51-19 57s45-21 54-37l64-113s1-2 4 2c1 3 5 2 5 2l22-9s5-2 4-7l-21-52-2 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693 492s0 6 17 38l45 94s-6 9-1 20c0 0 9 21 29 7 0 0 16-8 8-25 0 0-9-12-15-10 0 0-22-57-43-99-7-16-9-26-17-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700 660 57-18v1l-57 19v-2Zm89-24 57-18v1l-57 18v-1Zm-28-11-39-44 1-1 40 45h-2Zm-53 53 51-30v1l-51 31v-2Zm21 18 36-46 1 1-37 47v-2Zm30 13 11-57 1 1-11 58-1-2Zm27 4-9-65h1l10 66-2-1Zm35-15-41-49 1-1 38 46c3 3 2 4 2 4Zm19-26-53-27 1-1 53 27-1 1Zm7-22-58-10v-1l59 10-1 1Zm-11-57-47 35v-1l47-35v1Zm-16-17-33 48-1-1 34-49v2Zm-19-10-19 55-1-1 19-56 1 2Zm-20-7-2 65-1-1 2-65 1 1Zm-75 42 52 27-1 1-53-28h2Zm-9 22 59 9v1l-60-9 1-1Zm1 22 58-9v1l-59 10 1-2Zm67-27-3-58h1l3 59-1-1Zm-473 19 56-18v1l-57 19 1-2Zm89-24 56-19v2l-57 18 1-1Zm-29-11-39-44 1-1 40 45h-2Zm-52 53 50-30 1 1-52 31 1-2Zm17 20 36-46 1 1-37 47v-2Zm32 18 12-64 1 1-12 63h-1Zm28-3-8-64h1l8 65-1-1Zm37-13-43-52h1l43 52h-1Zm17-28-52-28v-1l54 28-2 1Zm7-22-58-10v-1l60 10-2 1Zm-10-57-47 35-1-1 48-36v2Zm-16-17-33 48-1-1 33-49 1 2Zm-20-10-19 55-1-1 19-56 1 2Zm-20-5-2 62h-1l1-62h2Zm-75 39 52 28v1l-53-28 1-1Zm-8 23 58 9v1l-60-9 2-1Zm0 22 58-9 1 1-60 10 1-2Zm71-23-3-58h1l3 59-1-1Zm-5-1-20-54 1-1 21 56-2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 595h-55l-78 1s-19 0-19 19c0 0-1 18 25 15 0 0 129-6 140-3 0 0 2-5 1-16 0 0 3-17-14-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 591s16-2 21-7l7 28 20-2s15 35 2 45h-26l-6-12c-5-8-14-18-12-23l-6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 680s12 0 15-4l-6-24-15 1 6 27Zm-34-99s7-3 19-4c0 0 8 1 5 9 0 0-13 8-21 7 0 0-8-3-3-12Zm-7-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492 584-15-41h18l14 36-17 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 510s-32-19-40-2c0 0-15 17 13 29 0 0 28 12 59 8l22-4-54-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 544s-2 47-15 60c0 0-11 15-7 18l-7 23c0 4 46 2 46 2s18-39 20-60l11-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 621s-14 10-22 29c0 0-5 19-11 25 0 0-15 13-16 17 0 0-2 3 10 10 0 0 20 20 29 24 0 0 11 3 11-6v-3s0-14-7-21l5-5s2-6-3-3c0 0 28-33 34-43 0 0-2-14-11-18-8-5-19-6-19-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 676s-4-8-5-3l1 7m33 29s18 11 0 17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M493 701a8 8 0 0 0-6 14h1l3 1v1l3 1 2 1c1 2-1 4-2 5l-1 1h-1l-1 1c3 0 7-1 9-3 3-2 3-6 3-9-1-5-4-9-8-12l-2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 269s10 1 11 10c0 0 1 6-2 10l-1-2v-8s0-6-8-8c-7-2 4 7 4 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 275s5 5 8 4l6 1v2s-8 0-11-3m-71 342s-7 19-2 42c0 0 7 22 5 31 0 0-6 23-4 27 0 0-1 4 15 3 0 0 33 8 45 5 0 0 13-3 7-12l-2-3s-10-13-21-16l2-8s-1-7-5-1c0 0 6-49 6-63 0 0-12-13-23-11-11 1-23 6-23 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 698s-8-4-6 1 5 6 5 6m39 5s16 2 8 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 703a7 7 0 1 0-1 14h7c2 1 2 5 2 7v1c2-2 4-4 5-8l-2-6-2-4-1-1-1-1-7-2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 161s7 12 7 15c0 0-2-7-7-10m-72-64 8-11-5 11c0 2-9 3-9 3m-3 3s3-7-6-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 92s-9 17-2 14m-7-12s-4 7 1 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 95s13 10 8 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 94s2 16-5 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 98s17 3 17 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 101s11-1 15 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 102c-1 0 19 0 17 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 104s25-4 26 4c1 7-10 6-10 6M433 584l-54 24v-1l54-25v2Zm15 52-57-15 1-1 57 15-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 507c-59 0-107 48-107 108v1a107 107 0 0 0 214 0v-1c0-60-48-108-107-108Zm0 34a74 74 0 1 1 0 148c-41 0-75-33-75-74s34-74 75-74Zm409-12c-59 0-107 48-107 107v1a107 107 0 0 0 214 0v-1c0-59-48-107-107-107Zm1 33c41 0 75 33 75 74v1c0 40-34 73-75 73-42 0-76-33-76-73v-1c0-41 34-74 76-74Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.80b7521513edb6cc16cb70a7161e0e1e.svg";
export { ForwardRef as ReactComponent };